module.exports = __webpack_public_path__ + "static/media/1417943445.8adecfa2.ttf";